import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { BannerConfig } from '@landing/models/banner-config';
import { RpcButtonComponent } from '../../../core-modules/controls/components/rpc-button/rpc-button.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'landing-banner',
    templateUrl: './landing-banner.component.html',
    styleUrls: ['./landing-banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RpcButtonComponent, TranslateModule]
})
export class LandingBannerComponent {
    @Input() public config: BannerConfig;

    @Output() public bannerButtonClicked = new EventEmitter<void>();

    public onBannerButtonClicked(): void {
        this.bannerButtonClicked.emit();
    }
}
